import { useEffect, useRef, useState } from "react";
import { Grid } from "../../../../../../Layout/Grid/GridView";
const TableStatsView = ({ data }) => {
  const gridTablesReservedRef = useRef();
  return data ? (
    <div>
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Nº Mesas Reservadas
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.numberReservations}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                    <i
                      className="fas fa-credit-card text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
        {/* <div className="col-12 col-sm-4">
          <div className="card card-stats mb-4 mb-xl-0 cards-bg">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Nº Entradas
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data[0] && data[0]["Nº Entradas"]}
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                    <i
                      className="fas fa-user-check"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div> */}
        <div className="col-12 col-sm-6">
          <div className="card card-stats bg-dark mb-4 mb-xl-0 cards-bg">
            <div className="card-body card-body-bg-dark box-venue">
              <div className="row">
                <div className="col">
                  <h5 className="card-title text-uppercase text-muted mb-0">
                    Total de Vendas
                  </h5>
                  <span className="h2 font-weight-bold mb-0">
                    {data.totalValueReservations} €
                  </span>
                </div>
                <div className="col-auto">
                  <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                    <i
                      className="fa-solid fa-money-bill text-light"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                </div>
              </div>
              <p className="mt-3 mb-0 text-muted text-sm">&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12">
          <Grid
            ref={gridTablesReservedRef}
            rows={data.list}
            height="100vh"
            pagination={true}
            cols={[

              { headerName: "Data", field: "date" },
              { headerName: "Mesa", field: "name" },
              { headerName: "Cliente", field: "owner_name" },
              { headerName: "Telemovel", field: "phone_number" },
              { headerName: "Email", field: "owner_email" },
              { headerName: "% Pré-Pagamento", field: "percentage_pre_payment" },
              { headerName: "Valor (€)", field: "total_price_payment" },
              { headerName: "Promotor", field: "promotor_name" },
              {
                headerName: "Check-In", field: "check_in", cellRenderer: (params) => {
                  return (
                    <div className="text-center">
                      {params.data.check_in ? (
                        <i className="fa-solid fa-check text-success"></i>
                      ) : (
                        <i className="fa-solid fa-times text-danger"></i>
                      )}
                    </div>
                  );
                },
              },
              { headerName: "Hora Check-In", cellStyle: { textAlign: 'center' }, field: "check_in_datetime" },
            ]}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default TableStatsView;
